const actions = {
    clear({ commit }) {
        return new Promise((resolve) => {
            const customer = JSON.parse(localStorage.getItem('customer'))

            localStorage.clear()

            commit('clear', customer)

            resolve(customer)
        })
    },
    setAutenticacao({ commit }, autenticacao) {
        localStorage.setItem('autenticacao', JSON.stringify(autenticacao))
        commit('setAutenticaco', autenticacao)
    },
    setCentroCusto({ commit }, centroCusto) {
        localStorage.setItem('centro_custo', JSON.stringify(centroCusto))
        commit('setCentroCusto', centroCusto)
    },
    setCliente({ commit}, cliente) {
        localStorage.setItem('cliente', JSON.stringify(cliente))
        commit('setCliente', cliente)
    },
    setCustomer({ commit }, customer) {
        return new Promise(resolve => {
            localStorage.setItem('customer', JSON.stringify(customer))
            commit('setCustomer', customer)

            resolve(customer)
        })
    },
    setExportacaoBpaEmAndamento({ commit }, value) {
        localStorage.setItem('exportacao_bpa_em_andamento', value)
        commit('setExportacaoBpaEmAndamento', value)
    },
    setExportacaoEsusEmAndamento({ commit }, value) {
        localStorage.setItem('exportacao_esus_em_andamento', value)
        commit('setExportacaoEsusEmAndamento', value)
    },
    setFila({ commit }, params) {
        localStorage.setItem('fila', JSON.stringify(params))
        commit('setFila', params)
    },
    setLoading({ commit }) {
        commit('setLoading')
    },
    setLotacao({ commit }, lotacao) {
        localStorage.setItem('lotacao', JSON.stringify(lotacao))
        commit('setLotacao', lotacao)
    },
    setMenu({ commit }, menu) {
        localStorage.setItem('menu', JSON.stringify(menu))
        commit('setMenu', menu)
    },
    setQuantidadeNotasVersaoNovas({commit}, value) {
        localStorage.setItem('quantidade_notas_versao_novas', value)
        commit('setQuantidadeNotasVersaoNovas', value)
    },
    setQuantidadeNotificacoesNaoLidas({commit}, value) {
        localStorage.setItem('quantidade_notificacoes_nao_lidas', value)
        commit('setQuantidadeNotificacoesNaoLidas', value)
    },
    setRouterInfo({commit}, value) {
        commit('setRouterInfo', value)
    },
    setShowExitFormConfirmation({ commit }) {
        commit('setShowExitFormConfirmation')
    },
    setSidebar({commit}, value) {
        localStorage.setItem('sidebar', value)
        commit('setSidebar', value)
    },
    unsetLoading({ commit }) {
        commit('unsetLoading')
    },
    unsetShowExitFormConfirmation({ commit }) {
        commit('unsetShowExitFormConfirmation')
    },
}

export default actions